const MuiAutocomplete = {
  inputRoot: {
    '&[class*="MuiFilledInput-root"]': {
      paddingTop: 0,
      paddingLeft: 10,
      '& $input': {
        padding: '14px 0'
      }
    }
  }
};
export default MuiAutocomplete;